import baseRequest from "../_core/baseRequest";

export default {
    // Adjustment Types CRUD
    getAdjustmentTypes: params =>
        baseRequest.get(
            `/courier-adjustments-type/list?${params?.name ? `name=${params.name}` : ""}${
                params?.type ? `&type=${params.type}` : ""
            }${params?.skip ? `&skip=${params.skip}` : ""}${
                params?.limit ? `&limit=${params.limit}` : ""
            }${params?.category ? `&category=${params.category}` : ""}`
        ),
    createAdjustmentType: params => baseRequest.post("/courier-adjustments-type/", params),
    updateAdjustmentType: (id, params) =>
        baseRequest.put(`/courier-adjustments-type/${id}`, params),
    deleteAdjustmentType: id => baseRequest.patch(`/courier-adjustments-type/${id}/soft-delete`),

    // Courier Adjustments
    getCourierAdjustments: params => {
        const queryParams = new URLSearchParams();
        const hasIsProcessed = params?.isProcessed !== undefined && params?.isProcessed !== null;
        // Borç durumu filtresi seçiliyse tarih aralığı gönderilmez
        if (params?.startDate && !hasIsProcessed) queryParams.append("startDate", params.startDate);
        if (params?.endDate && !hasIsProcessed) queryParams.append("endDate", params.endDate);
        if (params?.tckn) queryParams.append("tckn", params.tckn);
        if (params?.fullname) queryParams.append("fullname", params.fullname);
        if (params?.adjustmentTypeId)
            queryParams.append("adjustmentTypeId", params.adjustmentTypeId);
        if (hasIsProcessed) queryParams.append("isProcessed", params.isProcessed);
        if (params?.skip !== undefined) queryParams.append("skip", params.skip);
        if (params?.limit !== undefined) queryParams.append("limit", params.limit);
        if (params?.excel !== undefined) queryParams.append("excel", params.excel);
        return baseRequest.get(
            `/courier-earning-adjustment/list?${queryParams.toString().replace(/\+/g, "%20")}`,
            undefined,
            params?.excel === true
        );
    },

    getCourierAdjustmentsTemplate: () =>
        baseRequest.get("/courier-earning-adjustment/excel-template"),

    uploadCourierAdjustments: params =>
        baseRequest.post("/courier-earning-adjustment/excel-import", params, true)
};
